module.exports = __webpack_public_path__ + "img/bg_intro_tunnel2.14021562.svg";